import React from 'react';
import { Flex, Button } from '@chakra-ui/react';

interface IProps {
  index: number;
  complete: boolean;
  handleOnSaveAndCloseClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
}

const ContinueButton = (props: IProps) => {
  const { index, complete, handleOnSaveAndCloseClick, label } = props;

  return (
    <Flex justifyContent="end">
      <Button
        id={`add-value-modal-confirm-button-${index}`}
        data-selector={`add-value-modal-confirm-button-${index}`}
        isDisabled={complete ? false : true}
        onClick={handleOnSaveAndCloseClick}
        variant="solid"
        size="lg"
      >
        {label ? label : 'Save & Continue'}
      </Button>
    </Flex>
  );
};

export { ContinueButton };
